var _circle, _circle2, _circle3, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEstimatedLaunchPrice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 27.5,
    r: 27,
    fill: "#0F1021"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 27.5,
    r: 27,
    fill: "url(#paint0_radial_1326_963)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 27.5,
    r: 27,
    stroke: "#464B8D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.3331 40C20.1568 40 14.3398 34.1801 14.3398 27C14.3398 19.8199 20.1568 14 27.3331 14C34.5094 14 40.3263 19.8199 40.3263 27C40.3263 34.1801 34.5094 40 27.3331 40ZM28.8939 25.2068V23.2844H33.2905V20.3529H21.3196V23.2844H25.7162V25.206C22.1431 25.3701 19.4559 26.0786 19.4559 26.9269C19.4559 27.7751 22.1431 28.4828 25.7162 28.6477V34.8081H28.8939V28.6461C32.4613 28.482 35.142 27.7743 35.142 26.9269C35.142 26.0794 32.4613 25.3717 28.8939 25.2068ZM28.8939 28.1237V28.1221C28.8046 28.1286 28.3441 28.1562 27.3168 28.1562C26.4966 28.1562 25.9193 28.1318 25.7162 28.1221V28.1245C22.5589 27.9856 20.2022 27.4355 20.2022 26.7774C20.2022 26.1201 22.5589 25.57 25.7162 25.4286V27.5769C25.9225 27.5915 26.5137 27.6264 27.3306 27.6264C28.3108 27.6264 28.8021 27.5858 28.8939 27.5777V25.4303C32.0447 25.5708 34.3957 26.1209 34.3957 26.7774C34.3957 27.4355 32.0447 27.9839 28.8939 28.1237Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1326_963",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.5 27.5) rotate(1.14576) scale(137.527 82.5165)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5349CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101122",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEstimatedLaunchPrice);
export default __webpack_public_path__ + "static/media/icon_estimated_launch_price.acceb7308326afb5a2f1a0e8bac1d45d.svg";
export { ForwardRef as ReactComponent };